import * as api from 'services/api';

export const resolveMedia = (ids) => (dispatch) => {
  const list = (ids || []).filter(Boolean);
  if (list.length === 0) return Promise.resolve({});
  return api
    .get(`media?ids=${encodeURIComponent(list.join(','))}`, 'RESOLVE_MEDIA', dispatch)
    .catch(() => ({}));
};
